// src/data/allowedCountries.js
// ISO 3166-1 alpha-2 codes that meet cost cap at ~120 SMS/mo under $1.90.
// Start conservative; expand as you validate pricing on AWS.
const allowedCountries = [
	"US", // United States
	"CA", // Canada (AWS example shows ~$0.00581 + $0.00705 per SMS, ≈ $1.54/mo @120 msgs)
];

export default allowedCountries;
